(function() {
  if (window.cartUpsellInit) return;
  window.cartUpsellInit = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.cart-upsell-add');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Pridávam...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function() {
      return fetch('/cart?section_id=cart-drawer');
    })
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var currentInner = document.querySelector('cart-drawer .drawer__inner');

      if (newInner && currentInner) {
        currentInner.replaceWith(newInner);
      }
    })
    .catch(function(error) {
      console.error('Upsell add error:', error);
      button.disabled = false;
      button.textContent = originalText;
    });
  });
})();
